import observa4 from '@/sui/sc/helps/observa4'
import bactADI from '@/sui/sc/helps/bactADI'
import reaInfADI from '@/sui/sc/helps/reaInfADI'
import neoInfADI from '@/sui/sc/helps/neoInfADI'
import diaInfADI from '@/sui/sc/helps/diaInfADI'
import expADI from '@/sui/sc/helps/expADI'

export default {
  observa4,
  bactADI,
  reaInfADI,
  neoInfADI,
  diaInfADI,
  expADI
}
